import CustomIcon from "components/CustomIcon";
import Image from "next/image";
import { useDispatch } from "react-redux";
import { highlightSentences, clearHighlight } from "lib/redux/highlightSlice";
import type { SectionType } from "lib/redux/highlightSlice";

export const DoesNotEndsWithPeriod = ({
  doesNotEndsWithPeriod,
  section = "experience",
  itemIndex = null,
}: {
  doesNotEndsWithPeriod: string[];
  section?: SectionType;
  itemIndex?: number | null;
}) => {
  const dispatch = useDispatch();

  // Handle hover on individual sentence that doesn't end with period
  const handleSentenceMouseEnter = (sentence: string) => {
    dispatch(
      highlightSentences({
        section,
        itemIndex,
        sentences: [sentence],
      })
    );
  };

  const handleMouseLeave = () => {
    dispatch(clearHighlight());
  };
  return (
    <div className="relative mt-4 flex flex-col gap-[10px] rounded-xl bg-[#0F8D041C] px-[15px] py-[10px] md:mt-3 lg:gap-[16px] lg:px-[20px] lg:py-[14px]">
      <div className="absolute left-4 top-[-16px] flex items-center gap-2 rounded-xl bg-white px-4 py-2 font-bold text-black shadow-md lg:left-8 lg:px-6">
        <Image
          src="/icons/score-check/SentenceMistakes.svg"
          height={24}
          width={24}
          alt="icon"
          className="h-4 w-4 lg:h-5 lg:w-5 bg-transparent"
        />
        <span className="text-sm font-bold lg:text-base xl:text-lg">
          Does Not End With Period
        </span>
      </div>
      <ul className="mt-4 flex max-w-full list-disc flex-col items-start px-[3px] marker:text-base marker:text-[#92C5FF] sm:px-[5px] sm:marker:text-lg md:mt-3 lg:marker:text-2xl">
        {doesNotEndsWithPeriod.map((mistake, idx) => {
          const words = mistake.trim().split(/\s+/);
          const truncated =
            words.length > 12 ? words.slice(0, 12).join(" ") + "..." : mistake;

          return (
            <li
              key={idx}
              className="lg:base my-[6px] flex w-full cursor-pointer items-center gap-2 whitespace-break-spaces rounded-lg bg-[#FDFDFD] p-2 pl-2 text-xs font-medium text-[#B94444] transition-opacity hover:opacity-80 md:text-base lg:my-[6px] lg:gap-4 xl:my-[10px] xl:pl-3 "
              onMouseEnter={() => handleSentenceMouseEnter(mistake)}
              onMouseLeave={handleMouseLeave}
            >
              {truncated}
            </li>
          );
        })}
      </ul>
      <div className="mt-4 flex flex-col items-center justify-center gap-3">
        <div className="relative h-32 w-32 lg:h-40 lg:w-40">
          <Image
            src="/assets/resumeScore/SentenceMistakes.png"
            alt="Sentence mistakes illustration"
            fill
            className="object-contain"
          />
        </div>
        <p className="text-center text-xs  text-gray-600 lg:text-sm">
          Sentences should end with a period.
        </p>
        {/* <p className="text-center text-xs text-gray-600 lg:text-sm">
                Avoid using personal pronouns to maintain a professional tone.
              </p> */}
      </div>
    </div>
  );
};
